module.exports = __webpack_public_path__ + "search.ffd051d0b22ddbadfcf1.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/search.svg
// module id = ../../../../../src/assets/images/search.svg
// module chunks = styles